module.exports = __webpack_public_path__ + "static/media/profile_selection.78e5cc6c.png";